import { Task } from './task';

export const MOCKTASKS: Task[] = [
  {
    title: 'Prepare show',
    category: 'incremental',
    description: 'make a connection to oisfoisduidf',
    member: ['Patrick Lindqvist', 'Anna Kindblom']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/monday-tasks/monday-tasks/mock-tasks.ts